/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventTooltipsActionsTooltip } from './IntegrationEventTooltipsActionsTooltip';
import {
    IntegrationEventTooltipsActionsTooltipFromJSON,
    IntegrationEventTooltipsActionsTooltipFromJSONTyped,
    IntegrationEventTooltipsActionsTooltipToJSON,
} from './IntegrationEventTooltipsActionsTooltip';

/**
 * 
 * @export
 * @interface IntegrationEventTooltipsActions
 */
export interface IntegrationEventTooltipsActions {
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationEventTooltipsActions
     */
    enabled_buttons?: Array<IntegrationEventTooltipsActionsEnabledButtonsEnum>;
    /**
     * 
     * @type {IntegrationEventTooltipsActionsTooltip}
     * @memberof IntegrationEventTooltipsActions
     */
    tooltip?: IntegrationEventTooltipsActionsTooltip;
}


/**
 * @export
 */
export const IntegrationEventTooltipsActionsEnabledButtonsEnum = {
    Dismiss: 'dismiss',
    Apply: 'apply',
    MarkAsApplied: 'mark_as_applied'
} as const;
export type IntegrationEventTooltipsActionsEnabledButtonsEnum = typeof IntegrationEventTooltipsActionsEnabledButtonsEnum[keyof typeof IntegrationEventTooltipsActionsEnabledButtonsEnum];


/**
 * Check if a given object implements the IntegrationEventTooltipsActions interface.
 */
export function instanceOfIntegrationEventTooltipsActions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventTooltipsActionsFromJSON(json: any): IntegrationEventTooltipsActions {
    return IntegrationEventTooltipsActionsFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsActionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltipsActions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled_buttons': !exists(json, 'enabled_buttons') ? undefined : json['enabled_buttons'],
        'tooltip': !exists(json, 'tooltip') ? undefined : IntegrationEventTooltipsActionsTooltipFromJSON(json['tooltip']),
    };
}

export function IntegrationEventTooltipsActionsToJSON(value?: IntegrationEventTooltipsActions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled_buttons': value.enabled_buttons,
        'tooltip': IntegrationEventTooltipsActionsTooltipToJSON(value.tooltip),
    };
}

